import React, {useContext,useState} from "react"


const ReloadContext=React.createContext()

export function useReload(){
    return useContext(ReloadContext)
}

export function ReloadProvider({children}){
    const [reload, setReload] = useState(false)

   

    return <ReloadContext.Provider value={{reload,setReload}}>
            {children}
    </ReloadContext.Provider>

}